import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { Typography, Box } from '@mui/material';

function PrivacyPage() {
  const sectionSpacing = { xs: '6rem', sm: '7rem', md: '7.8rem' };

  return (
    <>
      <NavBar isSimpleMode={true} />
      <section>
        <Box sx={{
          background: 'black',
          py: "4rem",
        }}>
          <Typography
            component='h1'
            sx={{
              color: 'white',
              fontSize: '3rem',
              textAlign: 'center',
              fontWeight: '800'
            }}>
            SplitEV Privacy Policy
          </Typography>

          <Box sx={{
            m: 'auto',
            width: '80%',
            maxWidth: '70rem',
          }} >
            <Typography sx={{ fontSize: '1.8rem', textAlign: 'justify', my: '4rem', fontWeight: '300' }}>
              We at SplitEV Inc. (“SplitEV,” “we,” “us,” or “our”) know that privacy is very important to you.
              We have created this privacy policy (the “Privacy Policy”) to describe what kinds of personal
              information we may obtain through:
            </Typography>

            <Box sx={{ m: 'auto', maxWidth: '40rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <li> Platforms
                <Box sx={{ m: 'auto', width: '90%', listStyleType: 'circle' }} >
                  <li> The SplitEV platform (the “Platform”), which is accessed via our website, www.SplitEV.co</li>
                </Box>
              </li>
              <li> Apps
                <Box sx={{ m: 'auto', width: '90%', listStyleType: 'circle' }} >
                  <li> Our mobile application (the “App”); </li>
                </Box>
              </li>
              <li> Websites
                <Box sx={{ m: 'auto', width: '90%', listStyleType: 'circle' }}>
                  <li>Our website, located at https://www.SplitEV.co/</li>
                </Box>
              </li>
              <li> When you interact with us in any other way </li>
            </Box>

            <Typography sx={{ fontSize: '1.8rem', textAlign: 'justify', my: '4rem', fontWeight: '300' }}>
              We explain how we may use and disclose that information, the steps we take to keep it secure, your
              choices regarding our use of this information, and how you how can contact us if you have any
              questions about our privacy practices. We will refer to the above-listed ways in which you may
              interact with us collectively as the “Services.” Capitalized terms not defined in this Privacy Policy
              shall have the meanings set forth in our Terms of Use.
            </Typography>

            <Typography sx={{ fontSize: '1.8rem', textAlign: 'justify', my: '4rem', fontWeight: '300' }}>
              By visiting the websites, platforms and applications listed above, or using the SplitEV Services,
              you accept the practices described in this Privacy Policy. If you do not agree to all of the terms of
              this Privacy Policy, you may not access or use the Services
            </Typography>


            {/* TABLE OF CONTENTS */}
            <Typography sx={{ fontWeight: '600', mx: '1rem', pt: { xs: '6rem', sm: '6.8rem', md: '7.4rem' }, pb: '3rem', fontSize: '1.6rem' }} id="table-of-content">TABLE OF CONTENTS</Typography>

            <ol className="tc_table_of_content">
              <li>
                <a href="#information-we-collect">Information we collect</a>
              </li>

              <li>
                <a href="#how-we-use-your-info"> How we use your information</a>
              </li>

              <li>
                <a href="#how-we-share-your-info"> How we share your information</a>
              </li>

              <li>
                <a href="#how-we-protect-your-info"> How we use protect information</a>
              </li>

              <li>
                <a href="#children-info">Children's information</a>
              </li>

              <li>
                <a href="#external-and-payment-providers">External website and payment service providers</a>
              </li>

              <li>
                <a href="#access-and-modification-info">Accessing and modyfying information and communication references</a>
              </li>

              <li>
                <a href="#do-not-track">Do not track</a>
              </li>

              <li>
                <a href="#nevada-residents">Notice to Nevada recidents</a>
              </li>

              <li>
                <a href="#notice-to-non-us-residents">Important note to non-U.S residents</a>
              </li>

              <li>
                <a href="#update-to-this-policy">Update to this privacy policy</a>
              </li>

              <li>
                <a href="#how-to-contact-us">How to contact us</a>
              </li>
            </ol>

            <ol className="">
              {/* INFORMATION WE COLLECT */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, fontSize: '1.6rem' }} id="information-we-collect">
                  INFORMATION WE COLLECT
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1.5rem' }}>
                  In the course of operating the Services, SplitEV collects or receives
                  Vehicle charge state.

                  <Box>
                    Read real time vehicle charge state <br />
                    • Control vehicle charging
                  </Box>

                  <Box>
                    Start and stop the vehicle charging <br />
                    • Vehicle information
                  </Box>

                  <Box>
                    Get make, model, year and other data directly from the EV <br />
                    • Vehicle location
                  </Box>

                  <Box>
                    Read location data as longitude, latitude, which may include the following personal details:
                  </Box>
                </Box>

                <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'lower-alpha', m: '2rem' }} >
                  <li>
                    <Typography variant='h5' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '500' }}>Contact Information</Typography>

                    When you sign up to use the Services or join our e-mail list you may be required to provide us
                    with personal information about yourself, such as your name, address, phone number, and e-mail
                    address (collectively, the “Contact Information”). We do not collect any Contact Information
                    from you when you use our Services unless you provide us with the Contact Information
                    voluntarily.
                  </li>

                  <li>
                    <Typography variant='h5' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '500' }}>Billing Information</Typography>

                    To rent an EV Charger through a Platform, you will be required to provide certain information in
                    addition to the Contact Information noted above. Such information may include a debit card
                    number, credit card number, billing address, expiration date, security code and similar
                    information (collectively, the “Billing Information”).
                  </li>

                  <li>
                    <Typography variant='h5' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '500' }}>Geolocational Information</Typography>

                    To provide access to the Services while you are using an electronic device, we automatically
                    collect geolocational information from your mobile device, your wireless carrier, or certain third-party service
                    providers (“Geolocational Information”). Collection of such Geolocational
                    Information occurs only when the Services are running on your mobile device. You may control
                    the collection of Geolocational Information through the user settings on your device. You may
                    decline to allow us to collect such Geolocational Information, in which case SplitEV will not be
                    able to provide certain services to you. Please be sure to manage your mobile device and privacy
                    preferences on the Platform on an ongoing basis.
                  </li>


                  <li>
                    <Typography variant='h5' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '500' }}>Electric Vehicle Information</Typography>

                    If you are a Host, in addition to the Contact Information, you may be required to provide us with
                    the location and type of electric vehicle charger (“EV Charger”) you have. If you are a
                    Subscriber, in addition to the Contact Information and Billing Information, you may be required
                    to provide additional information concerning your electric vehicle such as your car type and your
                    vehicle identification number (“VIN”), your car’s battery status and your car’s odometer status.
                  </li>

                  <Box component='li' sx={{ textAlign: 'justify' }}>
                    <Typography variant='h5' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '500', textAlign: 'justify' }}>Other Information</Typography>

                    In addition to the Contact Information, the Billing Information, and the Geolocational
                    Information, we may collect additional information regarding you and your use of our Services,
                    your interactions with us and our advertising, as well as information regarding your computer or
                    other devices used to access our Services (collectively, the “Other Information”). Such Other
                    Information may include:

                    <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'disc', m: '2rem' }} >
                      <li>
                        <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                          Information obtained from your online activity
                        </Typography>. Information that we automatically collect when you use the Services, such as (i) information about the device from which
                        you access the Services (i.e., the type of device, the advertising identifier (“IDFA” or
                        “AdID”), the operating system and version (for example iOS, Android or Windows), your
                        carrier and network type (WiFi, 3G, 4G, LTE); (ii) your IP addresses (which may consist
                        of a static or dynamic IP address and will sometimes point to a specific identifiable
                        computer or device); (iii) browser type and language; (iv) referring and exit pages and
                        URLs; (v) date and time; (vi) amount of time spent on particular pages; (vii) what
                        features of the Services you use or visit, including your use of Platform (Direct, Discover,
                        or both); (viii) what you order and from which restaurants; and (ix) similar information
                        concerning your use of the Services.
                      </li>

                      <li>
                        <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                          Information we collect automatically through cookies, and similar technology
                        </Typography>. Like most online services, we automatically receive standard technical
                        information when you
                        connect with the Services. We collect this information through browser cookies, pixels,
                        web server logs, web beacons, and similar technologies. These features enable us to
                        personalize your experience with the Services, understand how you use them, maintain a
                        persistent session, and improve and further develop the Services. Cookies are small
                        packets of data that a website stores on your computer’s hard drive so that your computer
                        will “remember” information about your visit. We use cookies to help us collect Other
                        Information and to enhance your experience using the Services. Specifically, we
                        use cookies to authenticate users, personalize your experience when using the Services,
                        analyze which features of the Services you use most frequently, and measure and
                        optimize advertising and promotional effectiveness. To do this, we may use both session
                        cookies, which expire once you close your web browser, and persistent cookies, which
                        stay on your computer until you delete them. If you do not want the Services to place a
                        cookie on your hard drive, you may be able to turn that feature off on your computer or
                        mobile device. Please consult your Internet browser’s documentation for information on
                        how to do this. However, if you decide not to accept cookies from us, the Services may
                        not function properly. When the Services are made available to you through third-party
                        sites, please be aware that these other sites maintain their own policies regarding cookies
                        and the collection and use of information. You are responsible for reviewing those
                        policies.
                      </li>

                      <li>
                        <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                          Information obtained from other sources, including our social media pages.
                        </Typography> We may
                        collect personal information from our users and visitors of other sites on which you have
                        used the Services. We will do so in accordance with the terms of use and privacy policies
                        of those sites and applicable law. This includes our social media pages on places like
                        Facebook, Instagram, and Twitter. For example, we may collect the information you
                        shared on our social media pages through an application or form, which will have a link
                        to this Privacy Policy. Personal information may also be collected by the third-party
                        social media sites that host our social media pages. These sites may provide aggregate
                        information and analysis to us about visitors' use of our social media pages. This allows
                        us to better understand and analyze our user growth, general demographic information
                        about the users of these pages, and interaction with the content that we post. Overall, this
                        information may be used to help us understand the types of visitors and users of our
                        social media pages and use of the content. This Privacy Policy does not cover personal
                        information collected by such third party social media sites. For more information on
                        their privacy and security practices please review the privacy policies and terms of use on
                        their respective websites.
                      </li>

                      <li>
                        <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                          Information obtained from third-party analytics services
                        </Typography>. We use third-party analytics
                        services (such as Google Analytics) to evaluate your use of the Services, compile reports
                        on activity, collect demographic data, analyze performance metrics, and collect and
                        evaluate other information relating to the Services and mobile and internet usage. These
                        third parties use cookies and other technologies to help analyze and provide us the data.
                        By accessing and using the Services, you consent to the processing of data about you by
                        these analytics providers in the manner and for the purposes set out in this Privacy Policy.
                        The information used by such analytics services is generally at the aggregate level. To the
                        extent any such information is at the individual level or is used for secondary marketing
                        purposes, Canadian users may opt-out of such collection or use by sending an e-mail to
                        [PLEASE INPUT EMAIL ADDRESS] or writing to us at:


                        <Typography variant='blockquote' sx={{ maxWidth: '20rem', m: '1.2rem 15%', display: 'block' }}>
                          SplitEV, Inc. <br />
                          377 Valley Rd Clifton NJ, #1310
                          Clifton, New Jersey 07013
                        </Typography>

                        For more information on Google Analytics, including how to opt out from certain data
                        collection, please visit https://www.google.com/analytics. Please be advised that if you
                        opt out of any service, you may not be able to use the full functionality of the Services.
                      </li>
                    </Box>
                  </Box>
                </Box>

              </li>

              {/* HOW WE USE YOUR INFORMATION */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', py: '2rem', pt: sectionSpacing, fontSize: '1.6rem' }} id="how-we-use-your-info">
                  HOW WE USE YOUR INFORMATION
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem' }}>
                  We use your personal information to provide the Services to you, and to operate our business.
                  These business services include:

                  <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'disc', my: '2rem', textAlign: 'justify' }} >
                    <li>
                      <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                        Service-Related Usage:
                      </Typography> We use the Contact Information, Electric Vehicle Information and
                      the Other Information to provide and support the Services, such as communicating with
                      you and other customers, managing user accounts, providing customer service, informing
                      you about our products and services, and maintaining our systems. We use the Billing
                      Information to process your subscriptions, and we use the Geolocational Information to
                      recommend nearby EV Chargers to you.
                    </li>

                    <li>
                      <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                        Analyzing and Improving the Services:
                      </Typography> We may run calculations, aggregate, normalize,
                      clean, and make derivative works of the information obtained about you in order to

                      <Box component='ol' sx={{ display: 'flex', gap: '2rem', flexDirection: 'column', listStyleType: 'circle', m: '2rem' }} >
                        <li>Understand and analyze usage trends and preferences;</li>
                        <li>Monitor and analyze the effectiveness of the Services;</li>
                        <li>Improve the Services and develop new products, services, features, and
                          functionality; and</li>
                        <li>Test the Services and our infrastructure to make sure the Services are working
                          correctly.</li>
                      </Box>
                    </li>

                    <li>
                      <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                        Marketing:
                      </Typography> As permitted by applicable law, we may use the Contact Information and the
                      Other Information for marketing purposes, such as informing you about our products and
                      services. Where required under applicable law, we will obtain your prior opt-in consent to
                      send you electronic marketing communications.
                    </li>
                  </Box>
                </Box>
              </li>

              {/* HOW WE SHARE YOUR INFORMATION */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', py: '2rem', pt: sectionSpacing, fontSize: '1.6rem' }} id="how-we-share-your-info">
                  HOW WE SHARE YOUR INFORMATION
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem' }}>
                  We may share transfer, or disclose Contact Information, Billing Information, Geolocational
                  Information, Electric Vehicle Information and/or Other Information if you consent to us doing so,
                  as well as in the following circumstances:

                  <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'disc', m: '3rem', textAlign: 'justify' }} >
                    <li>
                      <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                        To provide our Services to you.
                      </Typography> To provide you with our Services, if you are a host, we
                      need to share your name, phone number, physical address and EV Charger location with a
                      Subscriber and if you are a Subscriber we need to share your name, phone number and
                      car type with a Host.
                    </li>

                    <li>
                      <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                        To better understand and serve our customers.
                      </Typography>  In an ongoing effort to better
                      understand our users and our Services, we might analyze Contact Information, Billing
                      Information, Geolocational Information, Electric Vehicle Information and/or Other
                      Information in aggregate form in order to operate, maintain, manage, and improve the
                      Services. This aggregate information does not identify you personally. We may share this
                      aggregate data with our affiliates, agents, and business partners. We may also disclose
                      aggregated user statistics in order to describe our products and services to current and
                      prospective business partners and to other third parties for other lawful purposes.
                    </li>

                    <li>
                      <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                        To assist us running our business.
                      </Typography>  We may employ other companies and individuals to
                      perform functions on our behalf. Examples may include providing marketing assistance,
                      billing, and customer service. These other companies will have access to the Contact
                      Information, the Billing Information, the Geolocational Information, the Electric Vehicle
                      Information and the Other Information only as necessary to perform their functions and
                      to the extent permitted by law..
                    </li>

                    <li>
                      <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                        As part of the sale or other transfer of our business.
                      </Typography> As we develop our businesses, we
                      might sell or buy businesses or assets. In the event of a corporate sale, merger,
                      reorganization, sale of assets, dissolution, investment, or similar corporate event, the
                      Contact Information, Billing Information, Geolocational Information Electric Vehicle
                      Information, and Other Information may be part of the transferred assets..
                    </li>

                    <li>
                      <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700' }}>
                        For legal purposes.
                      </Typography> To the extent permitted by law, we may also disclose Contact
                      Information, the Billing Information, the Geolocational Information, Electric Vehicle
                      Information and the Other Information when required by law, court order, or other
                      government or law enforcement authority or regulatory agency, or whenever we believe
                      that disclosing such information is necessary or advisable, for example, to protect the
                      rights, property, or safety of SplitEV or others..
                    </li>
                  </Box>

                  We will take reasonable measures to require that any party receiving any of your personal
                  information from us undertakes to: (i) retain and use such information only for the purposes set
                  out in this Privacy Policy; (ii) not disclose your personal information except with your consent,
                  as permitted by law, or as permitted by this Privacy Policy; and (iii) generally protect the privacy
                  of your personal information.
                </Box>
              </li>

              {/*  HOW WE PROTECT YOUR INFORMATION */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', py: '2rem', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="how-we-protect-your-info">
                  HOW WE PROTECT YOUR INFORMATION
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  We take commercially reasonable steps to protect the Contact Information, the Billing
                  Information, the Geolocational Information, Electric Vehicle Information, and the Other
                  Information from loss, misuse, and unauthorized access, disclosure, alteration, or destruction.
                  Please understand, however, that no security system is impenetrable. We cannot guarantee the
                  security of our databases, nor can we guarantee that the information you supply will not be
                  intercepted while being transmitted to and from us over the Internet. In particular, e-mail sent to
                  or from the Platform may not be secure, and you should therefore take special care in deciding
                  what information you send to us via e-mail.
                </Box>
              </li>

              {/*   CHILDREN’ INFORMATION */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', py: '2rem', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="children-info">
                  CHILDREN’ INFORMATION
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>

                  We do not knowingly collect personal information from children under the age of 13 through the
                  Services. If you are under 13, please do not give us any personal information. We encourage
                  parents and legal guardians to monitor their children’s Internet usage and to help enforce our
                  Privacy Policy by instructing their children to never provide us personal information without
                  their permission. If you have reason to believe that a child under the age of 13 has provided
                  personal information to us, please contact us, and we will endeavor to delete that information
                  from our databases.
                </Box>
              </li>

              {/*    EXTERNAL WEBSITES AND PAYMENT SERVICE PROVIDERS */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="external-and-payment-providers">
                  EXTERNAL WEBSITES AND PAYMENT SERVICE PROVIDERS
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  The Services may contain links to third-party websites. SplitEV has no control over the privacy
                  practices or the content of any of our business partners, advertisers, sponsors, or other websites
                  to which we provide links. As such, we are not responsible for the content or the privacy policies
                  of those third-party websites. You should check the applicable third-party privacy policy and
                  terms of use when visiting any other websites.
                </Box>
              </li>

              {/*  ACCESSING AND MODIFYING INFORMATION AND COMMUNICATION PREFERENCES */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="access-and-modification-info">
                  ACCESSING AND MODIFYING INFORMATION AND COMMUNICATION
                  PREFERENCES
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  If you have registered for the Services, you may access, review, delete and make changes to your
                  Contact Information, Billing Information, and certain Other Information by following the
                  instructions found on our website, or the SplitEV App, as applicable. In addition, you may
                  manage your receipt of marketing and non-transactional communications by clicking on the
                  “unsubscribe” link located on the bottom of any SplitEV marketing email. Registered Users (i.e.
                  individuals who register to use the Services) cannot opt out of receiving transactional e-mails
                  related to their account. We will use commercially reasonable efforts to process such requests in
                  a timely manner. You should be aware, however, that it is not always possible to completely
                  remove or modify information in our subscription databases. In such case, we will provide you
                  the reason why the modification or removal was not possible.
                </Box>
              </li>

              {/*  DO NOT TRACK */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="do-not-track">
                  DO NOT TRACK
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>

                  As discussed above, third parties such as advertising networks and analytics providers may
                  collect information about your online activities over time and across different websites when you
                  access or use the Services. Currently, various browsers offer a “Do Not Track” option, but there
                  is no standard for commercial websites. At this time, we do not monitor, recognize, or honor any
                  opt-out or do not track mechanisms, including general web browser “Do Not Track” settings and/
                  or signals.
                </Box>
              </li>

              {/*  NOTICE TO NEVADA RESIDENTS */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="nevada-residents">
                  NOTICE TO NEVADA RESIDENTS
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  Press@splitev.app
                </Box>
              </li>

              {/*  IMPORTANT NOTICE TO NON-U.S. RESIDENTS */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="notice-to-non-us-residents">
                  IMPORTANT NOTICE TO NON-U.S. RESIDENTS
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  The Services are operated in the United States. If you are located outside of the United States,
                  please be aware that any information you provide to us will be transferred to the United States
                  where the privacy laws may not be as protective as those in your country of origin. If you are
                  located outside the United States and choose to use the Services, you consent to any transfer and
                  processing of your personal information in accordance with this Privacy Notice, and you do so at
                  your own risk.
                </Box>
              </li>

              {/*  UPDATES TO THIS PRIVACY POLICY */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="update-to-this-policy">
                  UPDATES TO THIS PRIVACY POLICY
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  This Privacy Policy is effective as of the date stated at the top of this Privacy Policy. We may
                  update this Privacy Policy from time to time and without prior notice to you to reflect changes in
                  our privacy practices. We will indicate at the top of this Privacy Policy when it was most recently
                  updated, and we encourage you to revisit this page periodically to stay aware of any changes. If
                  you access the Services after we have made changes to this Privacy Policy, you are deemed to
                  have accepted such changes.
                </Box>
              </li>

              {/*  HOW TO CONTACT US */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="how-to-contact-us">
                  HOW TO CONTACT US
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  If you have any questions or comments about this Privacy Policy, our privacy practices, or if you
                  would like to exercise your rights and choices, please email us at: <Box
                    component='a'
                    href="mailto:charge@splitev.co"
                    sx={{
                      color: "#fff",
                      fontSize: "1.4rem",
                      fontWeight: 400,
                      textAlign: "left",
                      textDecorationLine: "underline",
                      width: 'fit-content',
                      display: 'contents'
                    }}
                  >
                    charge@splitev.co
                  </Box>
                </Box>
              </li>
            </ol>
          </Box>

          <div>
            <Box component='a'
              href="#table-of-content"
              sx={{
                width: 'fit-content',
                textDecoration: 'none',
                position: 'fixed',
                right: '2rem',
                bottom: '2rem',
                border: '1rem',
                background: 'white',
                borderRadius: '5rem',
                p: '1.4rem', px: '2rem',
              }}
            >
              Table of Contents
            </Box>
          </div>
        </Box>
      </section >

      <Footer />
    </>
  );
}

export default PrivacyPage;